import { styled } from '@mui/material/styles';

export const StyledHeading = styled('div')({
  marginBottom: '12px',
});
